<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-10">
        <h2>Nowe tłumaczenia (frontend)</h2>
        <ol class="breadcrumb">
          <li>
            <router-link to="/">Home</router-link>
          </li>
          <li class="active">
            <strong>Nowe tłumaczenia</strong>
          </li>
        </ol>
      </div>
    </div>

    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Meta dane tłumaczeń</h5>
            </div>
            <div class="ibox-content">
              <div v-if="metaLoading">Ładowanie meta danych...</div>
              <div v-else>
                <p v-if="meta">
                  <strong>Wersja:</strong> {{ meta.version }}<br />
                  <strong>Ostatnia modyfikacja:</strong>
                  {{ meta.date_modified }}
                </p>
                <p v-else>
                  Brak danych o wersji tłumaczeń. Upewnij się, że istnieje
                  przynajmniej jeden rekord tłumaczeń.
                </p>

                <div v-if="meta">
                  <h5>Statyczne pliki tłumaczeń</h5>
                  <ul>
                    <li v-for="lang in ['pl', 'en', 'de']" :key="lang">
                      <a
                        :href="staticUrl(lang)"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ lang.toUpperCase() }} – {{ staticUrl(lang) }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Nowe tłumaczenia</h5>
            </div>
            <div class="ibox-content">
              <div class="row m-b-md">
                <div class="col-sm-12">
                  <button
                    v-if="canAdd"
                    @click="addNew"
                    class="btn btn-sm btn-primary"
                  >
                    <i class="fa fa-plus"></i>
                    Dodaj tłumaczenie
                  </button>
                  <button
                    @click="resetFilters"
                    class="btn btn-primary btn-xs m-l-sm"
                  >
                    <i class="fa fa-refresh"></i>
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 m-b-xs" v-if="items">
                  <div class="pagination" v-if="itemsAll">
                    <span class="items-all">
                      Ilość rekordów: <b>{{ itemsAll }}</b>
                    </span>
                    <span>
                      Ilość na stronę:
                      <select v-model="serverOptions.rowsPerPage">
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </span>
                    <span>
                      <input type="number" v-model="serverOptions.page" /> -
                      {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                    </span>
                    <button
                      @click="selectPage(1)"
                      class="btn btn-primary ml-25"
                    >
                      Pierwsza
                    </button>
                    <button
                      @click="serverOptions.page = serverOptions.page - 1"
                      :disabled="serverOptions.page === 1"
                      class="prev nl"
                    ></button>
                    <button
                      @click="serverOptions.page = serverOptions.page + 1"
                      :disabled="
                        serverOptions.page ===
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      "
                      class="next"
                    ></button>
                    <button
                      @click="
                        selectPage(
                          Math.ceil(itemsAll / serverOptions.rowsPerPage)
                        )
                      "
                      class="btn btn-primary"
                    >
                      Ostatnia
                    </button>
                  </div>

                  <EasyDataTable
                    v-model:server-options="serverOptions"
                    :server-items-length="itemsAll"
                    :headers="headers"
                    :items="items"
                    :clickRowToExpand="false"
                    click-event-type="double"
                    :loading="loading"
                    @click-row="editRow"
                    alternating
                    multi-sort
                    border-cell
                    @update-sort="updateSort"
                    class="table-search"
                  >
                    <template #header="header">
                      <span v-if="header.text">
                        {{ header.text }}
                      </span>
                      <input
                        class="table-search"
                        type="text"
                        v-if="header.search"
                        v-model="searchValue[header.value]"
                        @keyup="search"
                        @click="isSearch = true"
                      />
                    </template>

                    <template #item-key="item">
                      <div v-if="item.isNew || item.isEdit">
                        <input
                          v-model="currentForm.key"
                          name="key"
                          type="text"
                          class="form-control inputClass"
                          required="required"
                          placeholder="np. layout.main_page.title"
                        />
                      </div>
                      <span v-else>
                        {{ item.key }}
                      </span>
                    </template>

                    <template #item-text_pl="item">
                      <div v-if="item.isNew || item.isEdit">
                        <input
                          v-model="currentForm.text_pl"
                          name="text_pl"
                          type="text"
                          class="form-control inputClass"
                          required="required"
                        />
                      </div>
                      <span v-else>
                        {{ item.text_pl }}
                      </span>
                    </template>

                    <template #item-text_en="item">
                      <div v-if="item.isNew || item.isEdit">
                        <input
                          v-model="currentForm.text_en"
                          name="text_en"
                          type="text"
                          class="form-control inputClass"
                          required="required"
                        />
                      </div>
                      <span v-else>
                        {{ item.text_en }}
                      </span>
                    </template>

                    <template #item-text_de="item">
                      <div v-if="item.isNew || item.isEdit">
                        <input
                          v-model="currentForm.text_de"
                          name="text_de"
                          type="text"
                          class="form-control inputClass"
                          required="required"
                        />
                      </div>
                      <span v-else>
                        {{ item.text_de }}
                      </span>
                    </template>

                    <template #item-actions="item">
                      <div v-if="item.isNew">
                        <button
                          v-if="canAdd"
                          @click="createTranslation"
                          class="btn btn-success btn-xs"
                        >
                          <i class="fa fa-check"></i>
                        </button>
                        <button
                          @click="cancelNew"
                          class="btn btn-danger btn-xs"
                        >
                          <span class="fa fa-times"></span>
                        </button>
                      </div>
                      <div v-else>
                        <button
                          v-if="item.isEdit && canChange"
                          @click="updateTranslation"
                          class="btn btn-success btn-xs"
                        >
                          <i class="fa fa-check"></i>
                        </button>
                        <button
                          v-if="item.isEdit"
                          @click.stop="cancelEdit(item)"
                          class="btn btn-danger btn-xs"
                        >
                          <span class="fa fa-times"></span>
                        </button>
                        <button
                          v-if="!item.isEdit && canChange"
                          @click="editRow(item)"
                          class="btn btn-warning btn-xs"
                        >
                          <i class="fa fa-pencil"></i>
                        </button>
                        <button
                          v-if="!item.isEdit && canDelete"
                          @click.stop="
                            showModal = item.pk;
                            deleteName = item.key;
                          "
                          class="btn btn-danger btn-xs"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    </template>
                  </EasyDataTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal
      v-if="showModal"
      :title="'Potwierdzenie usunięcia'"
      :content="
        'Czy na pewno chcesz usunąć tłumaczenie <b>' + deleteName + '</b> ?'
      "
      @callbackOk="deleteTranslation(showModal)"
      @callbackClose="showModal = false"
    />
  </div>
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import Modal from "../caffeprint/Modal.vue";
import { hasPermission } from "../../permissions";
import { i18nTranslationPermissionsConst } from "../../constants/translationConstants";

export default {
  name: "I18nTranslationsList",
  components: {
    Modal,
  },
  setup() {
    const store = useStore();

    const i18nTranslationsData = computed(
      () => store.getters.getI18nTranslationsData
    );
    const i18nCreateTranslationData = computed(
      () => store.getters.getI18nCreateTranslationData
    );
    const i18nUpdateTranslationData = computed(
      () => store.getters.getI18nUpdateTranslationData
    );
    const i18nDeleteTranslationData = computed(
      () => store.getters.getI18nDeleteTranslationData
    );
    const i18nTranslationsMetaData = computed(
      () => store.getters.getI18nTranslationsMetaData
    );
    const items = ref([]);
    const itemsAll = ref(0);
    const loading = ref(true);
    const metaLoading = ref(true);
    const meta = ref(null);

    const showModal = ref(false);
    const deleteName = ref("");

    const searchValue = ref({});
    const isSearch = ref(false);
    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
    });

    const currentForm = ref({
      pk: null,
      key: "",
      text_pl: "",
      text_en: "",
      text_de: "",
    });

    const headers = [
      { text: "ID", value: "pk", sortable: true },
      {
        text: "Klucz",
        value: "key",
        sortable: false,
        search: true,
      },
      {
        text: "Polski",
        value: "text_pl",
        sortable: false,
        search: true,
      },
      {
        text: "Angielski",
        value: "text_en",
        sortable: false,
        search: true,
      },
      {
        text: "Niemiecki",
        value: "text_de",
        sortable: false,
        search: true,
      },
      {
        text: "Data dodania",
        value: "date_added",
        sortable: true,
      },
      {
        text: "Data modyfikacji",
        value: "date_modified",
        sortable: true,
      },
      { text: "Akcje", value: "actions" },
    ];

    const canAdd = computed(() =>
      hasPermission(i18nTranslationPermissionsConst.add)
    );
    const canChange = computed(() =>
      hasPermission(i18nTranslationPermissionsConst.update)
    );
    const canDelete = computed(() =>
      hasPermission(i18nTranslationPermissionsConst.delete)
    );

    const getI18nTranslations = async () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getI18nTranslations", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
      });
    };

    const getMeta = async () => {
      metaLoading.value = true;
      await store.dispatch("getI18nTranslationsMeta");
    };

    const editRow = (item) => {
      if (!canChange.value) {
        return;
      }
      let keyObj = false;
      for (const [key, value] of Object.entries(items.value)) {
        items.value[key].isEdit = false;
        if (value.pk === item.pk) {
          keyObj = key;
        }
      }
      if (keyObj !== false) {
        currentForm.value = {
          pk: item.pk,
          key: item.key,
          text_pl: item.text_pl,
          text_en: item.text_en,
          text_de: item.text_de,
        };
        items.value[keyObj].isEdit = true;
      }
    };

    const addNew = () => {
      if (!canAdd.value) {
        return;
      }
      for (const [key] of Object.entries(items.value)) {
        items.value[key].isEdit = false;
        items.value[key].isNew = false;
      }
      items.value.unshift({
        pk: null,
        key: "",
        text_pl: "",
        text_en: "",
        text_de: "",
        isNew: true,
        isEdit: true,
      });
      currentForm.value = {
        pk: null,
        key: "",
        text_pl: "",
        text_en: "",
        text_de: "",
      };
    };

    const cancelNew = () => {
      const idx = items.value.findIndex((i) => i.isNew);
      if (idx !== -1) {
        items.value.splice(idx, 1);
      }
      currentForm.value = {
        pk: null,
        key: "",
        text_pl: "",
        text_en: "",
        text_de: "",
      };
    };

    const cancelEdit = (item) => {
      const keyObj = items.value.findIndex((i) => i.pk === item.pk);
      if (keyObj !== -1) {
        items.value[keyObj].isEdit = false;
      }
      currentForm.value = {
        pk: null,
        key: "",
        text_pl: "",
        text_en: "",
        text_de: "",
      };
    };

    const createTranslation = () => {
      if (!canAdd.value) {
        return;
      }
      store.dispatch("createI18nTranslation", currentForm.value);
    };

    const updateTranslation = () => {
      if (!canChange.value) {
        return;
      }
      store.dispatch("updateI18nTranslation", currentForm.value);
    };

    const deleteTranslation = (pk) => {
      if (!canDelete.value) {
        return;
      }
      showModal.value = false;
      store.dispatch("deleteI18nTranslation", { pk });
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getI18nTranslations();
          isSearch.value = false;
        }, 500);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      serverOptions.value.sortBy = "";
      getI18nTranslations();
    };

    const updateSort = () => {
      search.value = true;
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const staticUrl = (lang) => {
      const base = process.env.VUE_APP_APIHOST || "";
      const ver =
        meta.value && meta.value.version ? `?ver=${meta.value.version}` : "";
      return `${base}/static_i18n/${lang}.json${ver}`;
    };

    onMounted(() => {
      getI18nTranslations();
      getMeta();
    });

    watch(
      () => i18nTranslationsData.value,
      (newValue) => {
        const data = newValue?.data;
        if (!data) {
          loading.value = false;
          return;
        }
        itemsAll.value = data.count;
        items.value = [];
        data.results?.forEach((element) => {
          items.value.push({
            ...element,
            isEdit: false,
            isNew: false,
          });
        });
        loading.value = false;
      }
    );

    watch(
      () => i18nTranslationsMetaData.value,
      (newValue) => {
        meta.value = newValue?.data || null;
        metaLoading.value = false;
      }
    );

    watch(
      () => i18nCreateTranslationData.value,
      (newValue) => {
        if (!newValue) return;
        if (newValue.status === 201) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Tłumaczenie zostało dodane",
          });
          getI18nTranslations();
          getMeta();
        }
      }
    );

    watch(
      () => i18nUpdateTranslationData.value,
      (newValue) => {
        if (!newValue) return;
        if (newValue.status === 200) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Tłumaczenie zostało zaktualizowane",
          });
          getI18nTranslations();
          getMeta();
        }
      }
    );

    watch(
      () => i18nDeleteTranslationData.value,
      (newValue) => {
        if (!newValue) return;
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Tłumaczenie zostało usunięte",
          });
          getI18nTranslations();
          getMeta();
        }
      }
    );

    watch(
      () => serverOptions.value,
      () => {
        if (!isSearch.value) {
          getI18nTranslations();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      headers,
      items,
      itemsAll,
      loading,
      metaLoading,
      meta,
      serverOptions,
      searchValue,
      isSearch,
      showModal,
      deleteName,
      currentForm,
      canAdd,
      canChange,
      canDelete,
      addNew,
      cancelNew,
      cancelEdit,
      editRow,
      createTranslation,
      updateTranslation,
      deleteTranslation,
      search,
      resetFilters,
      updateSort,
      selectPage,
      staticUrl,
    };
  },
};
</script>
